<p [ngClass]="cssClass">
  <img
    class="mr-3"
    *ngIf="icon"
    src="./assets/images/icons/{{ icon }}.png"
    alt="Icono en el texto"
    [hidden]="icon === undefined || icon === ''"
  />
  {{ text }}
</p>
